var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticStyle: { "margin-top": "5px" } }, [
      _c(
        "div",
        { staticClass: "button-click-left" },
        [
          _c(
            "el-select",
            {
              staticClass: "button-left-status",
              attrs: { placeholder: "Trạng thái" },
              on: {
                change: function ($event) {
                  return _vm.searchHeaderMethod()
                },
              },
              model: {
                value: _vm.dataSearch.status,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "status", $$v)
                },
                expression: "dataSearch.status",
              },
            },
            _vm._l(_vm.kidStatusList, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { value: item.key, label: item.value },
              })
            }),
            1
          ),
          this.getAppTypeUserLogin === "plus"
            ? _c(
                "el-select",
                {
                  staticClass: "button-left-class",
                  attrs: { clearable: "", placeholder: "Chọn khối" },
                  on: { change: _vm.changeGradeMethod },
                  model: {
                    value: _vm.dataSearch.idGrade,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataSearch, "idGrade", $$v)
                    },
                    expression: "dataSearch.idGrade",
                  },
                },
                _vm._l(_vm.gradeOfSchoolList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { value: item.id, label: item.gradeName },
                  })
                }),
                1
              )
            : _vm._e(),
          _c(
            "el-select",
            {
              staticClass: "button-left-class",
              attrs: {
                filterable: "",
                clearable: this.getAppTypeUserLogin === "plus",
                placeholder: "Chọn lớp",
              },
              on: { change: _vm.searchHeaderMethod },
              model: {
                value: _vm.dataSearch.idClass,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idClass", $$v)
                },
                expression: "dataSearch.idClass",
              },
            },
            _vm._l(_vm.classList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { value: item.id, label: item.className },
              })
            }),
            1
          ),
          _c("el-input", {
            staticClass: "button-left-class",
            staticStyle: { width: "280px" },
            attrs: { placeholder: "Nhập tên, biệt danh, SĐT", clearable: "" },
            on: {
              clear: function ($event) {
                return _vm.searchHeaderMethod()
              },
            },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.searchHeaderMethod()
              },
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c("el-button", {
                      attrs: { icon: "el-icon-search" },
                      on: {
                        click: function ($event) {
                          return _vm.searchHeaderMethod()
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.dataSearch.nameOrPhone,
              callback: function ($$v) {
                _vm.$set(_vm.dataSearch, "nameOrPhone", $$v)
              },
              expression: "dataSearch.nameOrPhone",
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticStyle: { "margin-top": "20px" } },
      [
        _c("el-col", { attrs: { span: 7 } }, [
          _c("div", { staticClass: "content-line-1 color-3" }, [
            _c("i", { staticClass: "el-icon-document-checked" }),
            _vm._v(
              "\n        Tổng số học sinh đang sử dụng thanh toán trực tuyến: " +
                _vm._s(_vm.numberStudentOnlinePayment) +
                "\n      "
            ),
          ]),
        ]),
        _c("el-col", { attrs: { span: 7, offset: 1 } }, [
          _c("div", { staticClass: "content-line-1 color-1" }, [
            _c("i", { staticClass: "el-icon-document-checked" }),
            _vm._v(
              "\n        Tổng số học sinh giới hạn sử dụng thanh toán trực tuyến: " +
                _vm._s(_vm.totalLimitConfigSchool) +
                "\n      "
            ),
          ]),
        ]),
        _c("el-col", { attrs: { span: 7, offset: 1 } }, [
          _c(
            "div",
            { staticClass: "content-line-1 color-4" },
            [
              _c("el-checkbox", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.onlinePaymentLimit,
                  callback: function ($$v) {
                    _vm.onlinePaymentLimit = $$v
                  },
                  expression: "onlinePaymentLimit",
                },
              }),
              _c("span", { staticStyle: { "margin-left": "10px" } }, [
                _vm._v(" Không cho phép vượt giới hạn"),
              ]),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "table-content row-data",
        staticStyle: { "margin-top": "80px" },
      },
      [
        _vm.multipleSelection.length > 0
          ? _c("span", [
              _vm._v("Đã chọn: " + _vm._s(_vm.multipleSelection.length)),
            ])
          : _vm._e(),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingData,
                expression: "loadingData",
              },
            ],
            ref: "multipleTable",
            attrs: {
              "empty-text": _vm.textTable,
              "element-loading-text": _vm.$tableLoading,
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(255,255,255, 0)",
              data: _vm.studentList,
              "highlight-current-row": "",
              "cell-style": _vm.tableRowStyle,
              "header-cell-style": _vm.tableHeaderColor,
              "max-height": _vm.$tableMaxHeight,
              border: "",
            },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                fixed: "",
                align: "center",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: {
                type: "index",
                fixed: "",
                align: "center",
                label: "STT",
                width: "50",
              },
            }),
            _c("el-table-column", {
              attrs: {
                fixed: "",
                align: "center",
                label: "Mã HS",
                prop: "kidCode",
                width: "120",
              },
            }),
            _c("el-table-column", {
              attrs: { "min-width": "170", fixed: "", label: "Họ tên" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.fullName) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "Biệt danh",
                prop: "nickName",
                "min-width": "100",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "maClass.className",
                "min-width": "130",
                label: "Lớp",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "gender",
                "min-width": "80",
                label: "Giới tính",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "enableOnlinePayment",
                width: "200",
                label: "Thanh toán trực tuyến",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-checkbox", {
                        attrs: { disabled: _vm.checkLimitOnlinePayment },
                        on: {
                          change: function ($event) {
                            return _vm.handleEnableOnlinePayment(scope.row)
                          },
                        },
                        model: {
                          value: scope.row.enableOnlinePayment,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "enableOnlinePayment", $$v)
                          },
                          expression: "scope.row.enableOnlinePayment",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "el-row",
          { attrs: { type: "flex" } },
          [
            _c(
              "el-col",
              { staticStyle: { margin: "15px 0" }, attrs: { span: 22 } },
              [
                _c(
                  "div",
                  { staticClass: "container_nav_page" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.pageNumber,
                        "page-sizes": _vm.$pageListDefaultUser,
                        "page-size": _vm.maxPageItem,
                        layout: _vm.$pageLayoutDefault,
                        total: _vm.pageTotal,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("el-col", { attrs: { span: 2 } }, [
              _c(
                "div",
                { staticStyle: { float: "right", margin: "15px 0" } },
                [
                  _c(
                    "el-dropdown",
                    { on: { command: _vm.handleCommand } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "button-bottom",
                          attrs: { type: "success" },
                        },
                        [
                          _vm._v("\n              Tác vụ\n              "),
                          _c("i", { staticClass: "el-icon-caret-bottom" }),
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "enableOnlinePayment" } },
                            [
                              _vm._v(
                                "Cho phép thanh toán trực tuyến\n              "
                              ),
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: "disableOnlinePayment" } },
                            [
                              _vm._v(
                                "Hủy thanh toán trực tuyến\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _vm._m(0),
        _c(
          "el-row",
          { attrs: { type: "flex" } },
          [
            _c(
              "el-col",
              { attrs: { span: 4 } },
              [
                _c("el-date-picker", {
                  attrs: {
                    clearable: false,
                    type: "month",
                    placeholder: "Chọn tháng",
                    "value-format": "M-yyyy",
                    format: "MM-yyyy",
                    "time-arrow-control": false,
                  },
                  on: { change: _vm.searchByPropertiesHistory },
                  model: {
                    value: _vm.month,
                    callback: function ($$v) {
                      _vm.month = $$v
                    },
                    expression: "month",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { staticStyle: { "margin-top": "10px" }, attrs: { span: 10 } },
              [
                _c("i", { staticClass: "el-icon-document-checked" }),
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(
                    "\n           Tổng số học sinh sử dụng lớn nhất khi thay đổi được ghi nhận trong tháng: " +
                      _vm._s(_vm.maxValueChange) +
                      "\n          "
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "table-content row-data",
            staticStyle: { "margin-top": "20px" },
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingDataHistory,
                    expression: "loadingDataHistory",
                  },
                ],
                ref: "multipleTable",
                attrs: {
                  "empty-text": _vm.textTable,
                  "element-loading-text": _vm.$tableLoading,
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(255,255,255, 0)",
                  data: _vm.studentListChange,
                  "highlight-current-row": "",
                  "cell-style": _vm.tableRowStyle,
                  "header-cell-style": _vm.tableHeaderColor,
                  "max-height": _vm.$tableMaxHeight,
                  border: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    fixed: "",
                    align: "center",
                    label: "STT",
                    width: "50",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "transactionDate",
                    label: "Thời gian thay đổi",
                    width: "300",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatDate(row.createdDate)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tổng số học sinh thay đổi gần nhất được ghi nhận",
                    prop: "numberStudentChange",
                    "min-width": "150",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#00a1ff",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClickShowStudents(
                                    scope.row.id,
                                    "change"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.numberStudentChange) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label:
                      "Tổng số học sinh đang sử dụng được ghi nhận khi thay đổi",
                    prop: "sumNumberStudentChangeUser",
                    "min-width": "150",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#00a1ff",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleClickShowStudents(
                                    scope.row.id,
                                    "all"
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.sumNumberStudentChangeUser) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticStyle: { margin: "15px 0" }, attrs: { span: 22 } },
                  [
                    _c(
                      "div",
                      { staticClass: "container_nav_page" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "current-page": _vm.pageNumber2,
                            "page-sizes": _vm.$pageListDefaultUser,
                            "page-size": _vm.maxPageItem2,
                            layout: _vm.$pageLayoutDefault,
                            total: _vm.pageTotal2,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange2,
                            "current-change": _vm.handleCurrentChange2,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("StudentChangeOnlinePaymentDialog", {
          attrs: {
            isStudentChangeOnlinePaymentDialog:
              _vm.isStudentChangeOnlinePaymentDialog,
            type: _vm.type,
            idHistory: _vm.idHistory,
            typeUser: _vm.typeUser,
          },
          on: { closeDialog: _vm.closeStudentChangeOnlinePaymentDialog },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
      _c(
        "span",
        { staticStyle: { "font-size": "20px", "font-weight": "bold" } },
        [_vm._v("Lịch sử thay đổi vượt hạn mức cho phép")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }